import tags from "../../../components/tags";
import { img } from "../../../components/html";
import gRepresentation from "./implicit-grant.jpg";
import text from "./text";

export default {
  "Implicit Grant: step 1": {
    post: {
      tags: [tags.accessTokens],
      summary: "Authorization Code Grant",
      description: `${text.description.summary}
      
## Graphical representation of token acquisition and communication with API 
${img(gRepresentation)}

## First step      
Server check parameters. The user will be prompted to sign in and confirm access. If everything goes without error, user will be redirect to the address specified in \`redirect_uri\` with the parameters in step 2`,

      parameters: [
        {
          name: "response_type",
          in: "query",
          required: true,
          description: "Response type - constant",
          schema: {
            type: "string",
            example: "code"
          }
        },
        {
          name: "client_id",
          in: "query",
          required: true,
          description: "Client identification key - Identity Key",
          schema: {
            type: "string",
            example: "CHANGE THIS"
          }
        },
        {
          name: "redirect_uri",
          in: "query",
          required: true,
          description:
            "Address to which the authorization code is sent after successful authorization. You must enable the redirect URI in the section `Nastavení integrace`.",
          schema: {
            type: "string",
            example: "CHANGE THIS"
          }
        },
        {
          name: "state",
          in: "query",
          required: true,
          description:
            "CSRF token - This parameter is not required but recommended.The client should store it in a session and compare it to the token that receives in response.",
          schema: {
            type: "string"
          }
        }
      ],

      security: []
    }
  }
};
